import { Injectable } from '@angular/core';
import { ISummaryData, ProductCatalogResponse, ProductInformation } from '../models/summary-data';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CatalogService {
  
  private catalogData: ProductCatalogResponse | null = null;
  private productInfoSubject = new Subject<ISummaryData>();
  productInfo$ = this.productInfoSubject.asObservable();

  constructor() { }

  setCatalog(data: ProductCatalogResponse) {
    this.catalogData = data;
  }

  getCatalog(): ProductCatalogResponse | null {
    return this.catalogData;
  }

  emitProductInfo(info: ISummaryData) {
    this.productInfoSubject.next(info);
  }
  
}
